import { t } from "i18next";
import { object, string } from "yup";

import { customFieldLabels } from "../../utils/address-utils";

const getLabel = (value: string) =>
  customFieldLabels[value] ?? customFieldLabels.CA;

export const addressSchema = object().shape({
  country: string().required().label(t("Country")),
  address: string().trim().required().label(t("Address")),
  city: string()
    .trim()
    .when(["country"], ([country], schema) => {
      return schema.required().label(getLabel(country).city);
    }),
  county: string()
    .trim()
    .label(t("County"))
    .when(["country"], ([country], schema) => {
      if (["US", "GB"].includes(country)) {
        return schema.required();
      }
      return schema;
    }),
  postal_code: string()
    .trim()
    .when(["country"], ([country], schema) => {
      return schema.required().label(getLabel(country).postal_code);
    }),
  province_state: string().label(t("Province, state or territory")),
});
